// import { Box, Button, DialogProps } from "@mui/material";
// import BasicModal from "../../components/modal/BasicModal";
// import DocumentViewer from "./DocumentViewerModal";
// interface Props extends DialogProps {
//   onClose: () => void;
//   documentUrl?: any;
//   mimeType?: any;
// }

// const DeleteUserModal = ({
//   onClose,
//   documentUrl,
//   mimeType,
//   ...props
// }: Props) => {
//   return (
//     <Box>
//       <BasicModal
//         onClose={onClose}
//         size={"lg"}
//         title="View Document"
//         height={800}
//         content={
//           <Box textAlign={"center"}>
//             <DocumentViewer documentUrl={documentUrl} mimeType={mimeType} />
//           </Box>
//         }
//         actions={
//           <>
//             <Button
//               variant="outlined"
//               sx={{ textTransform: "capitalize" }}
//               onClick={() => onClose()}
//               color="error"
//             >
//               Close
//             </Button>
//           </>
//         }
//         {...props}
//       />
//     </Box>
//   );
// };

// export default DeleteUserModal;

import { Box, Button, DialogProps } from "@mui/material";
import BasicModal from "../../components/modal/BasicModal";
import { useSnackbarHelper } from "../../components/Snackbar";
import { useEffect, useState } from "react";
import { getS3Url } from "../../../utils/s3";

interface Props extends DialogProps {
  onClose: () => void;
  fileUrl?: any; // Buffer of the PDF data to preview.
  title?: any;
  mimetype?: any;
  closeLoading?: any;
}

const ViewDigitalDocument = ({
  onClose,
  fileUrl,
  title,
  mimetype,
  closeLoading,
  ...props
}: Props) => {
  const showSnackbar = useSnackbarHelper();
  const [loadError, setLoadError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isLoaded) {
        setLoadError(true);
      }
    }, 5000); // 5 seconds timeout for loading
    return () => clearTimeout(timer);
  }, [isLoaded]);

  function shortenFileName(fileName: string, maxLength: number = 20): string {
    const extensionIndex = fileName.lastIndexOf(".");

    // Handle files without extensions
    if (extensionIndex === -1 || fileName.length <= maxLength) {
      return fileName; // Return original if it's shorter than maxLength
    }

    const name = fileName.substring(0, extensionIndex); // File name without extension
    const extension = fileName.substring(extensionIndex); // File extension

    if (fileName.length <= maxLength) {
      return fileName;
    }

    // Start part (first N characters) and end part (last N characters of name)
    const startPart = name.substring(0, 15);
    const endPart = name.substring(name.length - 5);

    return `${startPart}..${endPart}${extension}`;
  }
  useEffect(() => {
    if (closeLoading) {
      closeLoading(null);
    }
  }, []);
  return (
    <BasicModal
      onClose={onClose}
      title={title ? shortenFileName(title) : "View Document"}
      size="lg"
      height={800}
      isDownloading={isDownloading}
      content={
        <Box>
          {(fileUrl &&
            mimetype ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document") ||
          mimetype ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          mimetype === "image/tiff" ? (
            <iframe
              title="PDF Viewer"
              src={
                `https://docs.google.com/gview?url=${getS3Url(fileUrl)}&embedded=true` +
                "#zoom=100"
              }
              style={{ width: "100%", height: "calc(100vh - 250px)" }}
              loading="lazy"
            />
          ) : fileUrl && mimetype.startsWith("image/") ? (
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100vh - 400px)",
                overflow: "hidden",
              }}
            >
              <img
                src={getS3Url(fileUrl)}
                alt={title || "Preview"}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  border: "none",
                }}
              />
            </Box>
          ) : fileUrl && mimetype.startsWith("audio/") ? (
            <audio controls style={{ width: "100%" }}>
              <source src={getS3Url(fileUrl)} type={mimetype} />
              Your browser does not support the audio element.
            </audio>
          ) : (
            fileUrl && (
              <Box>
                {!loadError ? (
                  <iframe
                    title="PDF Viewer"
                    src={getS3Url(fileUrl) + "#zoom=100"}
                    style={{ width: "100%", height: "calc(95vh - 250px)" }}
                    onLoad={() => setIsLoaded(true)}
                  >
                    {" "}
                    {title}
                  </iframe>
                ) : (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{
                      width: "100%",
                      height: "calc(70vh - 150px)",
                      fontSize: "30px",
                    }}
                  >
                    {title}
                  </Box>
                )}
              </Box>
            )
          )}
        </Box>
      }
      actions={
        <Button
          variant="outlined"
          sx={{ textTransform: "none" }}
          onClick={() => onClose()}
          color="error"
        >
          Close
        </Button>
      }
      {...props}
    />
  );
};

export default ViewDigitalDocument;
